import { css } from 'styled-components'
import variables from 'assets/styles/variables'
import { media } from 'gipsy-ui'

export const layout = css`
  padding-left: 200px;
  padding-right: 100px;
  ${media['tablet-wide']`
    padding-left: ${parseInt(variables.sidebarWidth, 10) + 20}px;
    padding-right: 20px;
  `}
  ${media['phone-wide']`
    padding-left: 20px;
    padding-right: 20px;
  `}
`

export const teamLayout = css`
  padding-left: 200px;
  padding-right: 100px;
  ${media['tablet-wide']`
    padding-left: ${parseInt(variables.sidebarWidth, 10) + parseInt(variables.teamMembersWidth, 10) + 20}px;
    padding-right: 20px;
  `}
  ${media['phone-wide']`
    padding-left: 20px;
    padding-right: 20px;
  `}
`



// WEBPACK FOOTER //
// ./src/assets/styles/mixins.js